<template>
  <div>This is the Paypal Cancel Component</div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { logEvent, logException } from "@/common/logger";
const componentName = "CancelComponent";

logEvent("created", componentName);

onMounted(async () => {
  try {
    logEvent("mounted", componentName);
  } catch (err) {
    logException(err as Error, componentName);
  }
});
onUnmounted(() => {
  logEvent("unmounted", componentName);
});
</script>
